<template>
  <div class="text-tdefault-color grid grid-cols-2 gap-4 border-b border-balternative-color mb-4 pb-2">
    <div class="">
      <div class="capitalize">
        <a href="" @click.prevent="routeTo(data.productId)">{{ $toTitleCase(data.productTitle) }}</a>
      </div>
      <div class="">Art. nr.: {{ data.productId }}</div>
    </div>
    <div class="flex items-center gap-2 justify-end">
      <div class="flex items-center justify-between border rounded-md px-2 py-1 w-fit">
        <!-- Minus icon -->
        <MinusIcon
          @click.prevent="reduceQuantity()"
          class="h-5 w-5 flex-shrink-0 text-pdsPrimaryColor cursor-pointer"
          aria-hidden="true"
        />

        <!-- Input field -->
        <input
          v-model="data.quantity"
          type="number"
          min="1"
          max="999"
          maxlength="3"
          autocomplete="off"
          @change="saveProductQuantity(data.quantity)"
          class="w-12 text-center border-none focus:ring-0 focus:outline-none"
        />

        <!-- Plus icon -->
        <PlusIcon
          @click.prevent="increaseQuantity()"
          class="h-5 w-5 flex-shrink-0 text-pdsPrimaryColor cursor-pointer"
          aria-hidden="true"
        />
      </div>
      <button class="" @click.prevent="$emit('removeOrder', data.cartId)">
        <TrashIcon
          class="h-5 md:h-6 w-5 md:w-6 flex-shrink-0 inline-block text-pdsPrimaryColor cursor"
          aria-hidden="true"
        />
      </button>
    </div>
  </div>
</template>

<script>
import { useRouter } from 'vue-router';
import { shoppingCart$, updateShoppingCartItem, activePpwRecId$, assortmentFeatureEnabled$ } from '@/services';
import { ref, watch } from 'vue';
import { TrashIcon, PlusIcon, MinusIcon } from '@heroicons/vue/24/outline';

export default {
  name: 'Order',
  components: {
    TrashIcon,
    PlusIcon,
    MinusIcon
  },
  props: {
    data: Object
  },
  setup(props) {
    const router = useRouter();
    const shoppingCart = ref(null);
    const activePpwRecId = ref(null);
    const assortmentFeatureEnabled = ref(null);
    const lastValidQuantity = ref(0);

    shoppingCart$.subscribe((value) => {
      shoppingCart.value = value;
    });

    activePpwRecId$.subscribe((value) => {
      activePpwRecId.value = value;
    });

    assortmentFeatureEnabled$.subscribe((value) => {
      assortmentFeatureEnabled.value = value;
    });

    watch(
      props.data,
      (newValue) => {
        lastValidQuantity.value = newValue.quantity;
      },
      { immediate: true }
    );

    const routeTo = (productId) => {
      if (!assortmentFeatureEnabled.value) {
        router.push('/catalog/product/' + productId);
      } else {
        router.push('/aanvullenmagazijn/product/' + productId);
      }
    };

    const saveProductQuantity = (inputValue) => {
      let regex = /^[0-9]{1,3}$/;
      let quantity = parseInt(inputValue, 10);
      if (quantity <= 0) {
        quantity = 1;
      }
      if (quantity > 999) {
        quantity = 999;
      }
      if (!regex.test(quantity) || !quantity || quantity <= 0) {
        props.data.quantity = lastValidQuantity.value;
        return;
      }
      lastValidQuantity.value = quantity;
      updateProductQuantity(quantity);
    };

    const updateProductQuantity = (quantity) => {
      props.data.quantity = quantity;
      updateShoppingCartItem(shoppingCart.value, props.data, activePpwRecId.value);
    };

    const reduceQuantity = () => {
      if (props.data.quantity === 1) {
        return;
      }
      saveProductQuantity(props.data.quantity - 1);
    };

    const increaseQuantity = () => {
      if (props.data.quantity === 999) {
        return;
      }
      saveProductQuantity(props.data.quantity + 1);
    };

    return {
      shoppingCart,
      activePpwRecId,
      assortmentFeatureEnabled,
      lastValidQuantity,
      routeTo,
      saveProductQuantity,
      updateProductQuantity,
      reduceQuantity,
      increaseQuantity
    };
  }
};
</script>
